// Core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../../Middleware/axiosConfig";

// Utils
import { notifyError } from "Services/Utils/toastNotification";

// API End Points
import { API_END_POINTS } from "Middleware/apiEndpoints";

// API calls
//Get all staffs request
export const getAllStaffsRequest_ADMIN = createAsyncThunk(
  "getAllStaffsRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAllStaffsRequest_ADMIN}limit=${data?.limit}&page=${data?.page}&order_by=${data?.orderBy}&sort_by=${data?.sortBy}${data?.search ? `&search=${data.search}` : ''}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//add staffs request
export const addStaffsRequest_ADMIN = createAsyncThunk(
  "addStaffsRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addStaffsRequest_ADMIN}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//delete staff request
export const deleteStaffRequest_ADMIN = createAsyncThunk(
  "deleteStaffRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().delete(
      `${API_END_POINTS.deleteStaffRequest_ADMIN}${data?.userId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//update staff details request
export const updateStaffDetailsRequest_ADMIN = createAsyncThunk(
  "updateStaffDetailsRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.updateStaffDetailsRequest_ADMIN}${data?.userId}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Mark as inactive staff request
export const markAsActiveInactiveStaffRequest_ADMIN = createAsyncThunk(
  "markAsActiveInactiveStaffRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.markAsActiveInactiveStaffRequest_ADMIN}${data?.userId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Staff details customer type
export const customerTypeRequest_ADMIN = createAsyncThunk(
  "customerTypeRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit(true).get(
      `${API_END_POINTS.customerTypeRequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//File upload request
export const fileUploadRequest_ADMIN = createAsyncThunk(
  "fileUploadRequest_ADMIN",
  async (data) => {
    // Function to sanitize file names
    const sanitizeFileName = (fileName) => {
      const name = fileName.slice(0, fileName.lastIndexOf(".")) || "file";
      const extension = fileName.slice(fileName.lastIndexOf(".") + 1);

      // Normalize Unicode (e.g., 𝐆𝐨𝐣𝐨 → Gojo)
      const normalizedName = name.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

      // Remove any non-alphanumeric characters, hyphens, or underscores
      const cleanName = normalizedName.replace(/[^a-zA-Z0-9_-]/g, "");

      // Clean the file extension
      const cleanExtension = extension.replace(/[^a-zA-Z0-9]/g, "");

      return `${cleanName}.${cleanExtension}`;
    };


    // Sanitize files in the FormData
    const sanitizedFormData = new FormData();
    for (let [key, value] of data?.file.entries()) {
      if (value instanceof File) {
        const sanitizedFile = new File(
          [value],
          sanitizeFileName(value.name),
          { type: value.type }
        );
        sanitizedFormData.append(key, sanitizedFile);
      } else {
        sanitizedFormData.append(key, value);
      }
    }

    // API call
    const response = await APIKit(true).post(
      `${API_END_POINTS.fileUploadRequest_ADMIN}`,
      sanitizedFormData
    );

    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get country list request
export const getCountryListRequest_ADMIN = createAsyncThunk(
  "getCountryListRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getCountryListRequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get accessor list for assessmentBL request
export const getAccessorListForAssessmentBLrequest_ADMIN = createAsyncThunk(
  "getAccessorListForAssessmentBLrequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAccessorListForAssessmentBLrequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get industry list for assessmentBL request
export const getIndustryListForAssessmentBLrequest_ADMIN = createAsyncThunk(
  "getIndustryListForAssessmentBLrequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getIndustryListForAssessmentBLrequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getCompanyNameList_ADMIN = createAsyncThunk(
  "getCompanyNameList_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getCompanyNameListWithDetails}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.companies);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getUserListFromLastAssessment = createAsyncThunk(
  "getUserListFromLastAssessment",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getUserListFromLastAssessment}?company_name=${data?.company_name}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Create assessment request
export const createAssessmentBLrequest_ADMIN = createAsyncThunk(
  "createAssessmentBLrequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.createAssessmentBLrequest_ADMIN}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get all assessment request
export const getAllAssessmentRequest_ADMIN = createAsyncThunk(
  "getAllAssessmentRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAllAssessmentRequest_ADMIN}${data?.page}&limit=8&sort_by=${data?.sortBy}&order_by=${data?.orderBy}&filerByStatus=${data?.filerByStatus}${data?.search ? `&search=${data.search}` : ''}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get assessment details request
export const getAssessmentDetailsRequest_ADMIN = createAsyncThunk(
  "getAssessmentDetailsRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentDetailsRequest_ADMIN}${data?.assessmentId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get reports list request
export const getReportsListRequest_ADMIN = createAsyncThunk(
  "getReportsListRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getReportsListRequest_ADMIN}${data?.page}&limit=${data?.limit}&order_by=${data?.orderBy}&sort_by=${data?.sortBy}${data?.search ? `&search=${data.search}` : ''}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get dashboard backlog counts request
export const getDashboardBacklogCountsRequest_ADMIN = createAsyncThunk(
  "getDashboardBacklogCountsRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getDashboardBacklogCountsRequest_ADMIN}${data?.period}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get age of backlogs request
export const getAgeOfBacklogsRequest_ADMIN = createAsyncThunk(
  "getAgeOfBacklogsRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAgeOfBacklogsRequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get assessments submitted by companies request
export const getAssessmentsSubmittedByCompaniesRequest_ADMIN = createAsyncThunk(
  "getAssessmentsSubmittedByCompaniesRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAssessmentsSubmittedByCompaniesRequest_ADMIN}${data?.period}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get recommendations submitted by assessors request
export const getRecommendationsSubmittedByAssessorsRequest_ADMIN =
  createAsyncThunk(
    "getRecommendationsSubmittedByAssessorsRequest_ADMIN",
    async (data) => {
      // api hit
      const response = await APIKit().get(
        `${API_END_POINTS.getRecommendationsSubmittedByAssessorsRequest_ADMIN}${data?.period}`
      );
      if (response?.status === 200) {
        data?.callBack(response?.data?.data);
      } else {
        notifyError(response?.data?.message);
      }
      return response?.data;
    }
  );

//Get Recent Assessment request
export const getRecentAssessmentRequest_ADMIN = createAsyncThunk(
  "getRecentAssessmentRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getRecentAssessmentRequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get Recent Submission request
export const getRecentSubmissionRequest_ADMIN = createAsyncThunk(
  "getRecentSubmissionRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getRecentSubmissionRequest_ADMIN}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Update assessement due date request
export const updateAssessmentDueDateRequest_ADMIN = createAsyncThunk(
  "updateAssessmentDueDateRequest_ADMIN",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.updateAssessmentDueDateRequest_ADMIN}${data?.backlogId}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const notifyAssessor = createAsyncThunk(
  "notifyAssessor",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.notifyAssessor}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getCountryCode = createAsyncThunk(
  "getCountryCode",
  async (data) => {
    // api hit
    const response = await APIKit(true).get(`${API_END_POINTS.getCountryCode}`);
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);


export const getAllContactUsRequest = createAsyncThunk(
  "getAllContactUsRequest",
  async (data) => {
    // Build query parameters
    const params = new URLSearchParams({
      page: data.page,
      search: data.search || "",
      sortBy: data.sortBy || "DESC",
      orderBy: data.orderBy || "",
    });

    // API hit
    const response = await APIKit(false).get(
      `${API_END_POINTS.getAllContactUsRequest}?${params.toString()}`
    );

    if (response?.status === 200) {
      data?.callBack(response?.data);
    }

    if (response?.status === 400) {
      data.callBack(response?.data);
      notifyError(response?.data?.message);
    }

    return response?.data;
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: { isLoading: false, getAllAssessmentisLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    //Get all staffs request
    builder
      .addCase(getAllStaffsRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getAllStaffsRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getAllStaffsRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Add staffs request
    builder
      .addCase(addStaffsRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addStaffsRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addStaffsRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //delete staff request
    builder
      .addCase(deleteStaffRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteStaffRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteStaffRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //update staff details request
    builder
      .addCase(updateStaffDetailsRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(updateStaffDetailsRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(updateStaffDetailsRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Mark as active inactive staff request
    builder
      .addCase(markAsActiveInactiveStaffRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        markAsActiveInactiveStaffRequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        markAsActiveInactiveStaffRequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //File upload request
    builder
      .addCase(fileUploadRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fileUploadRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fileUploadRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get country list request
    builder
      .addCase(getCountryListRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getCountryListRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getCountryListRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get accessor list for assessmentBL request
    builder
      .addCase(getAccessorListForAssessmentBLrequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getAccessorListForAssessmentBLrequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getAccessorListForAssessmentBLrequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Get industry list for assessmentBL request
    builder
      .addCase(getIndustryListForAssessmentBLrequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getIndustryListForAssessmentBLrequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getIndustryListForAssessmentBLrequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Create assessment request
    builder
      .addCase(createAssessmentBLrequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(createAssessmentBLrequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(createAssessmentBLrequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get all assessment request
    builder
      .addCase(getAllAssessmentRequest_ADMIN.pending, (state) => {
        state.getAllAssessmentisLoading = "loading";
      })
      .addCase(getAllAssessmentRequest_ADMIN.fulfilled, (state, action) => {
        state.getAllAssessmentisLoading = "succeeded";
      })
      .addCase(getAllAssessmentRequest_ADMIN.rejected, (state, action) => {
        state.getAllAssessmentisLoading = "failed";
      });

    //Get assessment details request
    builder
      .addCase(getAssessmentDetailsRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getAssessmentDetailsRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getAssessmentDetailsRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get reports list request
    builder
      .addCase(getReportsListRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getReportsListRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getReportsListRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get dashboard count request
    builder
      .addCase(getDashboardBacklogCountsRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getDashboardBacklogCountsRequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getDashboardBacklogCountsRequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Get age of backlogs request
    builder
      .addCase(getAgeOfBacklogsRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getAgeOfBacklogsRequest_ADMIN.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getAgeOfBacklogsRequest_ADMIN.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    //Get assessments submitted by companies request
    builder
      .addCase(
        getAssessmentsSubmittedByCompaniesRequest_ADMIN.pending,
        (state) => {
          state.isLoading = "loading";
        }
      )
      .addCase(
        getAssessmentsSubmittedByCompaniesRequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getAssessmentsSubmittedByCompaniesRequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Get recommendations submitted by assessors request
    builder
      .addCase(
        getRecommendationsSubmittedByAssessorsRequest_ADMIN.pending,
        (state) => {
          state.isLoading = "loading";
        }
      )
      .addCase(
        getRecommendationsSubmittedByAssessorsRequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getRecommendationsSubmittedByAssessorsRequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Update assessement due date request
    builder
      .addCase(updateAssessmentDueDateRequest_ADMIN.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        updateAssessmentDueDateRequest_ADMIN.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        updateAssessmentDueDateRequest_ADMIN.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );
       builder
    // contact us list
    .addCase(getAllContactUsRequest.pending, (state) => {
      state.getAllContactUsisLoading = 'loading';
    })
    .addCase(getAllContactUsRequest.fulfilled, (state, action) => {
      state.getAllContactUsisLoading = 'succeeded';
      state.getAllContactUsData = action.payload;
    })
    .addCase(getAllContactUsRequest.rejected, (state) => {
      state.getAllContactUsisLoading = 'failed';
    });

  },
});

export default adminSlice.reducer;


